document.addEventListener('DOMContentLoaded', function () {
  if (!window.productData) {
    console.warn('product-messages.js: window.productData is missing');
    return;
  }

  var productType   = window.productData.type;
  var productTags   = window.productData.tags;
  var productVendor = window.productData.vendor;
  var isOnSale      = window.productData.isOnSale;

  var container = document.querySelector('.product-info__title');
  if (!container) return;

  var normalize = function (str) {
    return String(str || '').toLowerCase().trim();
  };

  var normalizedType   = normalize(productType);
  var normalizedVendor = normalize(productVendor);
  var normalizedTags   = Array.isArray(productTags) ? productTags.map(normalize) : [];

  // Product types that show the "views" style message
  var viewTypes = [
    'Road Bikes',
    'Mountain Bikes',
    'Triathlon Bikes',
    'Gravel Bikes',
    'Track Bikes',
    'Tubular Wheels'
  ].map(normalize);

  // Tags that should show the "purchases" style message
  var purchaseTags = [
    'Zipp Wheels',
    'Softgoods',
    'Computers / Watches',
    'Bike Helmets',
    'Cycling Gloves',
    'Chainrings',
    'Eyewear',
    'Cycling Shoes',
    'Saddles',
    'Tires',
    'E-Bikes',
    'Urban Bikes',
    'Shimano components',
    'SRAM components'
  ].map(normalize);

  // Vendors that should also show the "purchases" message
  var purchaseVendors = [
    'Assos',
    'Carbon-Ti',
    'Fizik',
    'Garmin',
    'Lake',
    'Campagnolo',
    'CeramicSpeed'
  ].map(normalize);

  var mode = null;
  var forceShow = false;

  // 1) Sale message (metafield custom.is_on_sale)
  if (isOnSale === true || normalize(isOnSale) === 'true') {
    mode = 'sale';
    forceShow = true;
  }

  // 2) Purchases message (tags OR vendors)
  if (
    !mode &&
    (
      normalizedTags.some(function (tag) { return purchaseTags.includes(tag); }) ||
      purchaseVendors.includes(normalizedVendor)
    )
  ) {
    mode = 'purchases';
  }

  // 3) Views message (types)
  if (!mode && viewTypes.includes(normalizedType)) {
    mode = 'views';
  }

  // If nothing matched, bail out
  if (!mode) return;

  var displayChance = 0.7;
  if (!forceShow && Math.random() > displayChance) {
    return;
  }

  var statValue = null;
  if (mode === 'views') {
    statValue = Math.floor(Math.random() * 11) + 3; // 3–13
  } else if (mode === 'purchases') {
    statValue = Math.floor(Math.random() * 5) + 1;  // 1–5
  }

  var iconViews = `
    <svg class="product-stat__icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 5c-7 0-10 7-10 7s3 7 10 7 10-7 10-7-3-7-10-7z" fill="#C00"/>
      <circle cx="12" cy="12" r="4" fill="#FFF"/>
      <circle cx="12" cy="12" r="1.5" fill="#FFF"/>
    </svg>
  `;

  var iconPurchases = `
    <svg class="product-stat__icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6 6h14l-1.5 9h-11z" fill="none" stroke="currentColor" stroke-width="2"/>
      <circle cx="9" cy="19" r="1.5" fill="currentColor"/>
      <circle cx="17" cy="19" r="1.5" fill="currentColor"/>
    </svg>
  `;

  var iconSale = `
    <svg class="product-stat__icon" viewBox="0 0 24 24" aria-hidden="true">
      <!-- Outer flame -->
      <path
        d="M12 2C10 4.5 9 6.5 9 8.5C9 9.7 9.4 10.6 10 11.3C8.6 11.7 7 13.2 7 15.5C7 18.5 9.2 21 12 21C14.8 21 17 18.5 17 15.5C17 13.1 15.8 11.5 14.4 10.7C13.4 10.1 13 9.3 13 8.3C13 6.4 12.3 4.6 12 2Z"
        fill="#C00"
      />
      <!-- Inner flame -->
      <path
        d="M12 9.5C11.2 10.5 10.7 11.5 10.7 12.4C10.7 13.1 11 13.7 11.4 14.1C10.6 14.4 9.8 15.3 9.8 16.5C9.8 18.1 10.9 19.3 12 19.3C13.1 19.3 14.2 18.1 14.2 16.5C14.2 15.2 13.6 14.2 12.8 13.8C12.3 13.5 12 13 12 12.3C12 11.4 12 10.6 12 9.5Z"
        fill="#FFEEEE"
      />
    </svg>
  `;

  var div = document.createElement('div');

  if (mode === 'views') {
    div.className = 'product-stat product-stat--views';
    div.innerHTML = iconViews + ' Other cyclists have looked at this <span>' + statValue + '</span> times today.';
  } else if (mode === 'purchases') {
    div.className = 'product-stat product-stat--purchases';
    div.innerHTML = iconPurchases + ' Other cyclists have purchased this <span>' + statValue + '</span> times in the last month.';
  } else if (mode === 'sale') {
    div.className = 'product-stat product-stat--sale';
    div.innerHTML = iconSale + ' <strong>On sale now</strong> — special pricing for a limited time.';
  }

  container.appendChild(div);
});